/// /////////////////////接口请求，具体对应和参数参考文档////////////////////
import http from '@/utils/http'
class Api {
  /*
  * 字典
  */
  getDics = () => {
    return http.post('/nobidmy/ser/dics')
  }
  /*
  * 登录 - 获取令牌
  */
  getToken = (data: any) => {
    return http.post('/nobidmy/login/get-token-m', data)
  }

  /*
  * 登出 - 销毁令牌
  */
  destroyToken = () => {
    return http.post('/admin/login/destroy')
  }

  /**
   * java字典
   */
  getConf = () => {
    return http.post('/guest/applet/conf')
  }

  /**
   * 手机号登录
   */
  getTokenM = (data: any) => {
    return http.post('/admin/login/get-token-m', data)
  }
  /**
   * 统一登录
   */
  TYLOGIN = (data: any) => {
    return http.post('/nobidmy/login/get-token-m', data)
  }
  /**
   * 发送验证码
   */
  sendVerifyCode = (data: any) => {
    return http.post('/nobidmy/login/send-verifycode', data)
  }


  /*
  * 通用请求
  */
  post = (code: string, data?: any) => {
    return http.post('/nobidmy/ser/api?sercode=' + code, data)
  }
  postU = (code: string, data?: any) => {
    return http.post('/admin/ser/api/' + code, data, {headers: {"Content-Type": "multipart/form-data;charset=utf-8"}})
  }


  /*
  * 通用请求
  */
  get = (code: string, token: any) => {
    return http.get('/nobidmy/ser/api?sercode=' + code, {headers: {token: token}})
  }

  /*
  * 获取菜单
  */
  menus = () => {
    return http.post('/nobidmy/ser/menus')
  }

  /*
  * 渠道列表删除渠道检查是否有关联产品
  * */
  getChannelProduct = (data: any) => {
    return http.post('/nobidmy/ser/get-channel-product', data)
  }

  /*
  * 收费方案产品下拉列表
  * */
  getProduct = () => {
    return http.post('/nobidmy/ser/get-product')
  }

  /*
  * 机构下架、删除支付方式，检查是否有产品只配置了当前一种支付方式
  * */
  getProductPaytype = (data: any) => {
    return http.post('/nobidmy/ser/get-product-paytype', data)
  }

  /*
  * 机构删除产品方案，检查是否有产品只配置了当前一种支付方式
  * */
  getProductPlan = (data: any) => {
    return http.post('/nobidmy/ser/get-product-plan', data)
  }

  /*
  *运营商下拉框
  * */
  getOperatorSection = () => {
    return http.post('/nobidmy/ser/get-operator-section')
  }

  /*
  *部门
  * */
  getDepartmentSection = () => {
    return http.post('/nobidmy/ser/get-department-section')
  }

  /*
  *角色
  * */
  getRoleSection = () => {
    return http.post('/nobidmy/ser/get-role-section')
  }

  /*
  *根据机构id获取机构产品方案
  * */
  getOrgPlan = (data: any) => {
    return http.post('/nobidmy/ser/get-org-plan', data)
  }

  /*
  *产品基础配置获取客户经理/后台用户列表
  * */
  getManageList = (data: any) => {
    return http.post('/nobidmy/ser/get-manage-list', data)
  }
  /*
  *获取保函格式、委托担保服务协议、反担保协议（个人、企业）、 征信查询函模板下拉列表/后台用户列表
  * */
  getTplSection = (data: any) => {
    return http.post('/nobidmy/ser/get-tpl-section', data)
  }
  /*
  *省市区
  * */
  getQhdm = (data: any) => {
    return http.post('/nobidmy/ser/get-qhdm', data)
  }

 /*
  *指定机构id获取对应的支付方式
  * */
  getOutorgPay = (data: any) => {
    return http.post('/nobidmy/ser/get-outorg-pay', data)
  }

  /*
  *上传模板文件
  * */
  getPolicy = (data: any) => {
    return http.post('/nobidmy/ser/get-policy', data)
  }

  /*
  *录单页面删除反担保协议
  * */
  delMeasures = (data: any) => {
    return http.post('/nobidmy/ser/del-measures', data)
  }
  /*
  *获取中介代理机构下拉列表
  * */
  getAgency = (data: any) => {
    return http.post('/nobidmy/ser/get-agency', data)
  }

  /*
  *根据机构id,产品种类bond_type获取条款
  * */
  getClause = (data: any) => {
    return http.post('/nobidmy/ser/get-clause', data)
  }

  /*
  *根据产品id机构id获取收费方案
  * */
  getOrgCharge = (data: any) => {
    return http.post('/nobidmy/ser/get-org-charge', data)
  }

  /*
  * 权限配置
  */
  auth = (data: any) => {
    return http.post('/nobidmy/ser/auth', data)
  }
}
export default new Api()
